import { motion } from "framer-motion";
import { resolveImg } from "@/lib/content";

const ease = [0.16, 1, 0.3, 1];

const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Manifesto = ({ c }) => {
  const chapters = c?.chapters || [];
  return (
    <section
      id="why"
      data-testid="manifesto-section"
      className="bg-[#FBF7F0] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="max-w-3xl mb-20 md:mb-32">
          <span className="text-xs uppercase tracking-[0.32em] text-[#0E6B3A]">
            {c?.manifesto_eyebrow}
          </span>
          <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl md:text-7xl leading-[0.95] tracking-tight text-[#8E1226]">
            {c?.manifesto_title}
          </h2>
        </Reveal>

        <div className="space-y-28 md:space-y-40">
          {chapters.map((ch, i) => {
            const flip = i % 2 === 1;
            const num = String(i + 1).padStart(2, "0");
            return (
              <div
                key={i}
                data-testid={`manifesto-chapter-${num}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 items-center"
              >
                <Reveal
                  className={`md:col-span-6 ${flip ? "md:order-2" : ""}`}
                >
                  <div className="overflow-hidden rounded-2xl clip-frame border border-[#8E1226]/10">
                    {resolveImg(ch.img) ? (
                      <img
                        src={resolveImg(ch.img)}
                        alt={ch.title}
                        className="w-full h-[320px] md:h-[480px] object-cover"
                      />
                    ) : (
                      <div className="w-full h-[320px] md:h-[480px] bg-[#F2E8D5]" />
                    )}
                  </div>
                </Reveal>
                <Reveal
                  delay={0.12}
                  className={`md:col-span-5 ${
                    flip ? "md:order-1 md:col-start-1" : "md:col-start-8"
                  }`}
                >
                  <div className="font-serif text-[#0E6B3A] text-6xl md:text-8xl leading-none mb-6">
                    {num}
                  </div>
                  <h3 className="font-serif font-normal text-3xl md:text-4xl leading-tight tracking-tight text-[#8E1226] mb-5">
                    {ch.title}
                  </h3>
                  <p className="text-[#6D726A] text-base md:text-lg leading-relaxed max-w-md">
                    {ch.body}
                  </p>
                </Reveal>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
